module.exports = __webpack_public_path__ + "static/media/18.8a17d3c9.mp3";